class Timeline {
  constructor(url) {
    if (url) {
      $.ajax({
        type: 'GET',
        url: url,
        dataType: 'json'
      }).fail((e) => {
        console.error(e);
      });
    }
  }
}

export { Timeline };
